<section
  class="form-container"
  *ngIf="state$ | async as state"
>
  <div class="form-container-header">
    <span
      data-cy="form-header"
      class="mat-headline-5 m-0"
      *ngIf="!!state?.data?.header"
    >{{ state?.data?.header }}</span>
    <button
      mat-flat-button
      class="md circle"
      (click)="modalService.close(state?.data?.closeWithoutAdditionalModal)"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <div class="card align-items-center border-0">
    <div class="card-body w-100">
      <ng-template #target></ng-template>
    </div>
  </div>
</section>
